import { useEffect } from 'react'
import { Flag } from '@components/lang/Lang'
import languages from '@constants/values/langs'

const LangInput = ({ langs = languages, name, methods, defaultValue = 'pl' }) => {
    const { register, unregister, setValue, watch } = methods
    const setLang = (value) => setValue(name, value)

    useEffect(() => {
        register(name)
        if (defaultValue) setLang(defaultValue)
        return () => unregister(name)
    }, [])

    const onClick = ({ currentTarget }) => {
        const value = currentTarget.getAttribute('value')
        if (value) setLang(value)
    }

    const currentValue = watch(name) || defaultValue

    return (
        <Wrapper>
            { langs.map(l => {
                const isActive = currentValue == l
                return (
                    <Flag key={l} l={l} onClick={onClick} style={isActive
                        ? { background: 'var(--gray)', border: '1px solid var(--input-border-c)', padding: 10 }
                        : { padding: 10 }} />
                )
            })}
        </Wrapper>
    )
}

function Wrapper ({ children }) {
    return <div style={{ display: 'flex', flexWrap: 'wrap', width: '100%' }}>
        {children}
    </div>
}

export default LangInput